import { ReactNode } from "react";
import { colors } from "../styles";

interface BaseProps {
  index?: number | string;
  checked: boolean;
  onChange?: (e: any) => void;
  label?: string;
  borderColor?: string;
  className?: string;
  /** 버튼 우측에 노출할 배지 (예: 추천). 있으면 label 좌측 + 배지 우측 정렬 */
  badge?: ReactNode;
}

const OptionButton = ({
  index,
  checked,
  label,
  onChange,
  borderColor = colors.orange650,
  className,
  badge,
}: BaseProps) => {
  return (
    <button
      style={{
        background:
          borderColor === colors.orange650
            ? "none"
            : checked
            ? colors.gray900
            : "none",
        border: `${
          checked ? `1px solid ${borderColor}` : `1px solid ${colors.gray400}`
        }`,
        width: "100%",
        borderRadius: "6px",
        padding: "8px",
        color: `${checked ? borderColor : colors.gray700}`,
        fontWeight: `${checked ? 600 : 400}`,
        whiteSpace: "pre-line",
        position: badge ? "relative" : undefined,
      }}
      className={className || "body3"}
      onClick={(e) => onChange?.(e)}
    >
      {label}
      {badge && (
        <span
          style={{
            position: "absolute",
            right: 8,
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          {badge}
        </span>
      )}
    </button>
  );
};

export default OptionButton;
